// @ts-check
import { DateFilterService } from '@bto-services/utils';
import { COMBINED_SLIDER_ENUMS } from '../combined-slider/const';

/**
 * Get match name for boosted odd
 * @param {import('./interfaces').TBoostedOddItem} data - raw boost odd
 */
function getMatchName(data) {
  if (!data.at || !data.ht) {
    return '';
  }
  return `${data.ht} vs ${data.at}`;
}

/**
 * Convert string of IDs to array of ID numbers
 * @param {import('./interfaces').TBoostedOddItem} data - raw boost odd
 */
function stringToArrayNumbers(data) {
  if (!data.mids) {
    return [];
  }
  return data.mids.split(',').map((id) => {
    return parseInt(id, 10);
  });
}

export default class BoostedOddItemModel {
  /**
   * @param {import('./interfaces').TBoostedOddItem} data - boosted odd
   */
  constructor(data) {
    /**
     * BoostedOdd id
     * @type {number}
     */
    this.id = data.id;
    /**
     * BoostedOdd description
     * @type {string|undefined}
     */
    this.description = data.d;
    /**
     * BoostedOdd original odd
     * @type {string}
     */
    this.originalOdd = '' + data.oo;
    /**
     * BoostedOdd current odd
     * @type {string}
     */
    this.currentOdd = '' + data.co;
    /**
     * BoostedOdd max stake
     * @type {number}
     */
    this.maxStake = data.ms;
    /**
     * BoostedOdd deactivation date
     * @type {string}
     */
    // this.deactivationDate = data.dd;
    this.deactivationDate = DateFilterService.localDate(
      data.dd,
      'datetime',
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.fullTimeFormat,
      true
    );
    /**
     * BoostedOdd superboost
     * @type {boolean}
     */
    this.isSuperBoost = data.sb;
    /**
     * BoostedOdd background image
     * @type {string|undefined}
     */
    this.backgroundImage = data.i;
    /**
     * BoostedOdd highlighted
     * @type {boolean}
     */
    this.IsHighlighted = data.n;
    /**
     * Tournament name, if boosted odd is from single tournament
     * @type {string}
     */
    this.tournamentName = data.t || '';
    /**
     * Tournament id, if boosted odd is from single tournament
     * @type {number}
     */
    this.tournamentId = data.ti;
    /**
     * Tournament template id
     * @type {number}
     */
    this.tournamentTemplateId = data.bt;
    /**
     * BoostedOdd event id, if boosted odd is from single match
     * @type {number}
     */
    this.eventId = data.mi;
    /**
     * BoostedOdd array of event ids, if boosted odd is from single/multiple matches
     * @type {array}
     */
    this.eventIds = stringToArrayNumbers(data);
    /**
     * BoostedOdd sport id
     * @type {number}
     */
    this.sportId = data.si;
    /**
     * BoostedOdd sport name
     * @type {string}
     */
    this.sport = data.s;
    /**
     * Category id, if boosted odd is from single category
     * @type {number|undefined}
     */
    this.categoryId = data.ci;
    /**
     * Category name, if boosted odd is from single category
     * @type {string}
     */
    this.categoryName = data.c || '';
    /**
     * BoostedOdd home team icon
     * @type {string|undefined}
     */
    this.homeTeamIcon = data.hti ? `${APP_SETTINGS.path.teamImageUrl}${data.hti}` : '';
    /**
     * BoostedOdd home team name
     * @type {string|undefined}
     */
    this.homeTeam = data.ht;
    /**
     * BoostedOdd away team icon
     * @type {string|undefined}
     */
    this.awayTeamIcon = data.ati ? `${APP_SETTINGS.path.teamImageUrl}${data.ati}` : '';
    /**
     * BoostedOdd away team name
     * @type {string|undefined}
     */
    this.awayTeam = data.at;
    /**
     * Boosted odd match name
     * @type {string}
     */
    this.matchName = getMatchName(data);
    /**
     * Order number
     * @type {number}
     */
    if (data.on) {
      this.orderNumber = data.on;
    }
    /**
     * Type
     * @type { typeof COMBINED_SLIDER_ENUMS.BOOSTED_ODDS }
     */
    this.type = COMBINED_SLIDER_ENUMS.BOOSTED_ODDS;
  }
}